<div *ngIf="isVisible" class="tutorial-overlay">
  <!-- Semi-transparent backdrop -->
  <div class="tutorial-backdrop" (click)="closeTutorial()"></div>
  
  <!-- Animated cursor -->
  <div class="animated-cursor" 
       [class.moving]="animationPhase === 'moving'"
       [class.hovering]="animationPhase === 'hovering'"
       [class.clicking]="animationPhase === 'clicking'">
    <div class="cursor-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M8.5 2L17.5 11L13 11.5L15.5 18L13 19L10.5 12L8.5 2Z" fill="white" stroke="black" stroke-width="1"/>
      </svg>
    </div>
  </div>
  
  <!-- Fake calendar date for demonstration -->
  <div class="demo-calendar-day" 
       [class.highlighted]="animationPhase === 'hovering' || animationPhase === 'clicking'">
    <span class="demo-day-number">15</span>
    <div class="demo-add-button" 
         [class.visible]="animationPhase === 'hovering' || animationPhase === 'clicking'"
         [class.clicked]="animationPhase === 'clicking'">
      <span class="demo-add-icon">+</span>
    </div>
  </div>
  
  <!-- Tutorial tooltip -->
  <div class="tutorial-tooltip" 
       [class.phase-start]="animationPhase === 'start'"
       [class.phase-moving]="animationPhase === 'moving'"
       [class.phase-hovering]="animationPhase === 'hovering'"
       [class.phase-clicking]="animationPhase === 'clicking'"
       [class.phase-complete]="animationPhase === 'complete'">
    
    <div class="tooltip-content">
      <div class="tooltip-header">
        <h4>💡 Dica: Adicionar Compromissos</h4>
        <button class="close-button" (click)="closeTutorial()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      
      <div class="tooltip-body">
        <div class="all-instructions">
          <div class="instruction-step" 
               [class.active]="animationPhase === 'start'"
               [class.inactive]="animationPhase !== 'start'">
            <span class="step-number">1.</span>
            <p>Aprenda como adicionar compromissos rapidamente!</p>
          </div>
          
          <div class="instruction-step" 
               [class.active]="animationPhase === 'moving'"
               [class.inactive]="animationPhase !== 'moving'">
            <span class="step-number">2.</span>
            <p>Passe o mouse sobre qualquer data no calendário...</p>
          </div>
          
          <div class="instruction-step" 
               [class.active]="animationPhase === 'hovering'"
               [class.inactive]="animationPhase !== 'hovering'">
            <span class="step-number">3.</span>
            <p>Um botão <span class="highlight-orange">+</span> laranja aparecerá no canto superior direito!</p>
          </div>
          
          <div class="instruction-step" 
               [class.active]="animationPhase === 'clicking'"
               [class.inactive]="animationPhase !== 'clicking'">
            <span class="step-number">4.</span>
            <p>Clique no <span class="highlight-orange">+</span> para adicionar um novo compromisso nesta data!</p>
          </div>
          
          <div class="instruction-step" 
               [class.active]="animationPhase === 'complete'"
               [class.inactive]="animationPhase !== 'complete'">
            <span class="step-number">✅</span>
            <p>Agora você já sabe como usar este recurso!</p>
          </div>
        </div>
      </div>
      
      <div class="tooltip-footer">
        <label class="dont-show-again">
          <input type="checkbox" [(ngModel)]="dontShowAgain" (change)="onDontShowAgainChange()">
          <span>Não mostrar novamente</span>
        </label>
        <button class="got-it-button" (click)="closeTutorial()">
          Entendi!
        </button>
      </div>
    </div>
    
    <!-- Tooltip arrow -->
    <div class="tooltip-arrow"></div>
  </div>
</div> 